import React from "react";
import PropTypes from "prop-types";

// Config
import featureFlagKeys from "src/config/featureFlagKeys";

// Hooks
import { useFeatureFlags } from "src/context/FeatureFlagsProvider";
import useTranslate from "src/hooks/useTranslate";

// Components
import LocationField from "src/components/Input/LocationField";
import MiniMap from "src/components/MiniMap/MiniMap";

const WhereStep = ({ coord, setCoord, setFieldValue }) => {
  const { featureFlags } = useFeatureFlags();
  const getText = useTranslate();

  return (
    <>
      <LocationField
        label={getText(
          "caseDetailPage.requiredIncidentDetails.locationSubtitle"
        )}
        name="location"
        placeholder={getText("caseIncidentsPage.locationPlaceholder")}
        setCoord={setCoord}
        setFieldValue={setFieldValue}
      />
      {featureFlags[featureFlagKeys.MINIMAP] && coord && (
        <MiniMap latitude={coord.lat()} longitude={coord.lng()} />
      )}
    </>
  );
};

WhereStep.propTypes = {
  coord: PropTypes.shape({ lat: PropTypes.func, lng: PropTypes.func }),
  setCoord: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired
};

WhereStep.defaultProps = {
  coord: null
};

export default WhereStep;
